module.exports = __webpack_public_path__ + "static/media/esignNavLogo.05970391.svg";